import * as React from 'react';
const CheckCircle = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
    <mask
      id="mask0_17709_24171"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="60"
      height="60"
    >
      <rect width="60" height="60" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_17709_24171)">
      <path
        d="M26.5006 41.4902L44.1256 23.8652L40.6256 20.3652L26.5006 34.4902L19.3756 27.3652L15.8756 30.8652L26.5006 41.4902ZM30.0006 54.9902C26.5423 54.9902 23.2923 54.334 20.2506 53.0215C17.2089 51.709 14.5631 49.9277 12.3131 47.6777C10.0631 45.4277 8.28186 42.7819 6.96936 39.7402C5.65686 36.6986 5.00061 33.4486 5.00061 29.9902C5.00061 26.5319 5.65686 23.2819 6.96936 20.2402C8.28186 17.1986 10.0631 14.5527 12.3131 12.3027C14.5631 10.0527 17.2089 8.27148 20.2506 6.95898C23.2923 5.64648 26.5423 4.99023 30.0006 4.99023C33.4589 4.99023 36.7089 5.64648 39.7506 6.95898C42.7923 8.27148 45.4381 10.0527 47.6881 12.3027C49.9381 14.5527 51.7194 17.1986 53.0319 20.2402C54.3444 23.2819 55.0006 26.5319 55.0006 29.9902C55.0006 33.4486 54.3444 36.6986 53.0319 39.7402C51.7194 42.7819 49.9381 45.4277 47.6881 47.6777C45.4381 49.9277 42.7923 51.709 39.7506 53.0215C36.7089 54.334 33.4589 54.9902 30.0006 54.9902Z"
        fill="#1A73E9"
      />
    </g>
  </svg>
);
export default CheckCircle;
